import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

import type { ExtensionPointAppProps } from '../types.ts';
import type { PageBannerForgeAppProps } from './PageBannerForgeApp.tsx';

export const ByLineForgeApp: LoadableType<ExtensionPointAppProps> = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ByLineForgeApp" */ './ByLineForgeApp.tsx'))
			.ByLineForgeApp,
});

export const ContentActionForgeApp: LoadableType<ExtensionPointAppProps> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ContentActionForgeApp" */ './ContentActionForgeApp.tsx'
			)
		).ContentActionForgeApp,
});

export const ContextMenuForgeApp: LoadableType<ExtensionPointAppProps> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ContextMenuForgeApp" */ './ContextMenuForgeApp.tsx'
			)
		).ContextMenuForgeApp,
});

export const FullPageForgeApp: LoadableType<ExtensionPointAppProps> = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-FullPageForgeApp" */ './FullPageForgeApp.tsx'))
			.FullPageForgeApp,
});

export const GlobalPageForgeApp: LoadableType<ExtensionPointAppProps> = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-GlobalPageForgeApp" */ './GlobalPageForgeApp.tsx'))
			.GlobalPageForgeApp,
});

export const GlobalSettingsForgeApp: LoadableType<ExtensionPointAppProps> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-GlobalSettingsForgeApp" */ './GlobalSettingsForgeApp.tsx'
			)
		).GlobalSettingsForgeApp,
});

export const HomepageFeedForgeApp: LoadableType<ExtensionPointAppProps> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-HomepageFeedForgeApp" */ './HomepageFeedForgeApp.tsx'
			)
		).HomepageFeedForgeApp,
});

export const SpaceSettingsForgeApp: LoadableType<ExtensionPointAppProps> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SpaceSettingsForgeApp" */ './SpaceSettingsForgeApp.tsx'
			)
		).SpaceSettingsForgeApp,
});

export const SpacePageForgeApp: LoadableType<ExtensionPointAppProps> = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-SpacePageForgeApp" */ './SpacePageForgeApp.tsx'))
			.SpacePageForgeApp,
});

export const CustomContentForgeApp: LoadableType<ExtensionPointAppProps> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-CustomContentForgeApp" */ './CustomContentForgeApp.tsx'
			)
		).CustomContentForgeApp,
});

export const BackgroundScriptForgeApp: LoadableType<ExtensionPointAppProps> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-BackgroundScriptForgeApp" */ './BackgroundScriptForgeApp.tsx'
			)
		).BackgroundScriptForgeApp,
});

export const PageBannerForgeApp: LoadableType<PageBannerForgeAppProps> = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-PageBannerForgeApp" */ './PageBannerForgeApp.tsx'))
			.PageBannerForgeApp,
});
